exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.wiki-header-slide-enter[data-v-4aeb4f18],\n.wiki-header-slide-leave-to[data-v-4aeb4f18] {\n  transform: translateY(-100%);\n}\n", ""]);

